import script from "./PaywallManage.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallManage.vue?vue&type=script&setup=true&lang=js"

import "./PaywallManage.vue?vue&type=style&index=0&id=51ff9654&lang=css"

const __exports__ = script;

export default __exports__